import { FC } from "react";
import { Datagrid, List, ReferenceField, TextField } from "react-admin";
import ClientName from "../../components/ClientData/components/ClientName";
import ClientPhoneNumber from "../../components/ClientData/components/ClientPhoneNumber";

import CustomPagination from "../../components/CustomPagination";
import EmptyDataText from "../../components/EmptyDataText";
import TimestampField from "../../components/TimestampField";
import { AppResource } from "../../types/resource.types";
import ChallengeSkillLevel from "./components/ChallengeSkillLevel";
import ChallengeStatus from "./components/ChallengeStatus";
import ReservationsTime from "./components/ReservationsTime";

const ChallengesList: FC<any> = (props) => {
  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      actions={false}
      exporter={false}
    >
      <Datagrid empty={<EmptyDataText message="No Challenges yet!" />}>
        <ClientName label="Client" />
        <ClientPhoneNumber label="Phone" />
        <ReferenceField
          label="Court"
          source="venue.courtId"
          reference={`${AppResource.courts}`}
          sortable={false}
          link={false}
        >
          <TextField source="name.en" />
        </ReferenceField>
        <ChallengeStatus label="Status" />
        <ChallengeSkillLevel label="Skill Level" />
        <ReservationsTime source="firstSlotTime" label="Reservation Time" />
        {/* <TimestampField source="firstSlotTime" label="Slot Time" sortable={false} /> */}
        <TimestampField source="createdAt" label="Created At" sortable={false} />
      </Datagrid>
    </List>
  );
};

export default ChallengesList;
